module.exports = ("npm");


//////////////////
// WEBPACK FOOTER
// ./~/@dp/dpapp/lib/type.js
// module id = 220
// module chunks = 0